<button
  class="btn btn-sm btn-outline-primary"
  *ngIf="changeRequest && checkIfCanViewChangeRequests()"
  (click)="OnViewClicked.emit(changeRequest.id)">
  <i class="fas fa-eye"></i> View Configuration
</button>
